import React, { memo } from 'react';
// import { useSelector } from 'react-redux';
import { EntidadeTemplate } from '../../../components/templates';

const EntidadePublicSession = memo(props => {
  // Aqui regra para avaliar token da url

  return <EntidadeTemplate key="entidade">{props.children}</EntidadeTemplate>;
});

EntidadePublicSession.propTypes = {};

export default EntidadePublicSession;
